<section class="container">
    <section class="connectors">
        <mat-card *ngFor="let supportedChannel of supportedChannels" class="connector">
            <mat-card-title>
                <mat-icon [ngClass]="{'active': supportedChannel.channel.status === 'active'}">check_circle</mat-icon>
                {{ supportedChannel.channel.displayName }}
            </mat-card-title>
            <mat-card-content>
                <mat-form-field appearance="standard">
                    <mat-label>Integration ID</mat-label>
                    <input matInput [value]="supportedChannel.channel._id || 'Please connect first.'" readonly />
                    <button mat-icon-button matSuffix [cdkCopyToClipboard]="supportedChannel.channel._id" *ngIf="supportedChannel.channel._id" matTooltip="Copy to clipboard" (click)="copied()">
                        <mat-icon>file_copy</mat-icon>
                    </button>
                </mat-form-field>
            </mat-card-content>
            <mat-card-actions>
                <button mat-button (click)="authorize(supportedChannel)" color="primary">Connect</button>
            </mat-card-actions>
        </mat-card>
    </section>
    <section *ngIf="context$ | async; let context" [ngSwitch]="context.user.profile.provider">
        <app-facebook-setup *ngSwitchCase="'facebook'" [context]='context$'></app-facebook-setup>
        <app-twitter-setup *ngSwitchCase="'twitter'" [context]='context$'></app-twitter-setup>
    </section>
</section>